/* eslint-disable no-eval */
import _ from 'lodash';
import { createHook, createStateHook, createStore, defaults } from 'react-sweet-state';
import { evaluate } from 'utils/eval';
import { processRules } from '../utils/validaciones';
defaults.devtools = true;
/**
 * @typedef {object} InitialStateDynamicForm
 * @property {import('components/DynamicForm/typedefs').Seccion[]} secciones
 * @property {object} campos
 * @property {object} fields
 * @property {object|any} catalogo
 * @type {InitialStateDynamicForm}
 */
export const initialState = {
  fields: {},
  secciones: [],
  campos: {},
  catalogo: {},
  sources: {},
};

const processProps = (stringCode, resources) => {
  if (!stringCode || stringCode?.trim?.() === '') {
    return {};
  }
  const getProps = evaluate(stringCode);

  return getProps(resources);
};

/**
 * @typedef {object} DynamicFormActions
 *
 * @function
 * @param {InitialStateDynamicForm} state
 *
 */
const actions = {
  setState: (/** @type {InitialStateDynamicForm} */ state) => {
    return ({ setState }) => setState(state);
  },
  setSecciones: (
    /** @type {import('components/DynamicForm/typedefs').Seccion[]} */ secciones,
    /** @type {object} */ recursos = {},
    /** @type {CallableFunction} */ onFinish = null
  ) => {
    return async ({ setState }) => {
      const fieldsMappeds = {};
      let sources = { ...recursos };

      const camposSeccionesObject = {};

      const seccionCamposMapper = (seccion) => (campo) => {
        const newCampo = {
          ...campo,
          seccionId: seccion.id,
          seccionCodigoCore: seccion.codigoCore,
        };
        camposSeccionesObject[campo.id] = newCampo;

        return newCampo;
      };

      const camposSecciones = secciones.flatMap((seccion) => [
        ...(seccion?.campos?.map?.(seccionCamposMapper(seccion)) || []),
        ...(seccion?.secciones?.flatMap?.((subSeccion) =>
          subSeccion?.campos?.map?.(seccionCamposMapper(subSeccion))
        ) || []),
      ]);

      sources.remap = () => actions.setSecciones(secciones, sources, onFinish);

      const camposMapper = (campo, _index, arrayCampos) => {
        sources = { ...sources, campo };

        if (
          campo?.showOn?.fields?.length === 0 &&
          (campo?.showOn?.custom?.trim?.() === '' || campo?.showOn?.custom?.trim?.() === undefined)
        ) {
          campo.showOn = undefined;
        }

        const suscribers = camposSecciones?.filter((suscriber) => {
          return suscriber?.showOn?.fields?.some((item) => item === campo.name);
        });

        if (suscribers?.length > 0) {
          const suscriptoresDuplicados = suscribers.filter((objeto, i) => {
            return (
              suscribers.some((o, j) => {
                return objeto.name === o.name && i !== j;
              }) && camposSeccionesObject[campo.id].seccionId !== objeto.seccionId
            );
          });

          const finalSuscribers = suscribers.filter((objeto) => {
            return !suscriptoresDuplicados.some((o) => {
              return objeto.id === o.id;
            });
          });

          const suscribersIds = {};
          const suscribersNames = {};

          finalSuscribers.forEach((suscriber) => {
            suscribersIds[suscriber?.id] = suscriber?.name;
            suscribersNames[suscriber?.name] = suscriber.id;
          });

          campo.suscribers = {
            ids: suscribersIds,
            names: suscribersNames,
          };
        }

        if (Array.isArray(campo?.showOn?.fields)) {
          if (!campo.showOn?.custom && campo?.showOn?.values?.length > 0) {
            campo.showOn.entries = {};
            campo.showOn.fields.forEach((field, index) => {
              const value = campo?.showOn?.values?.[index];
              campo.showOn.entries[field] = value;
            });
          }

          if (
            typeof campo?.showOn?.custom === 'string' &&
            campo?.showOn?.custom?.trim?.() !== '' &&
            campo?.showOn?.custom?.length !== 0
          ) {
            const funcion = evaluate(campo.showOn.custom);
            campo.showOn.custom = funcion({
              ...sources,
              campo,
            });
          }
        }

        if (campo.optionsSource) {
          campo.options = _.get(sources?.catalogo, campo.optionsSource, []);
        }

        switch (campo.type) {
          case 'ubicacionAigMex':
            campo.configuracion.codigoPostal = camposMapper(campo.configuracion.codigoPostal);
            campo.configuracion.estado = camposMapper(campo.configuracion.estado);
            campo.configuracion.municipio = camposMapper(campo.configuracion.municipio);
            campo.configuracion.colonia = camposMapper(campo.configuracion.colonia);
            break;
          case 'complienceQuestions':
            if (campo?.configuracion?.clienteActuaPorCuentaPropia) {
              campo.configuracion.clienteActuaPorCuentaPropia = camposMapper(
                campo.configuracion.clienteActuaPorCuentaPropia
              );
            }

            if (campo?.configuracion?.gastoEstimadoAnualSuperaMonto) {
              campo.configuracion.gastoEstimadoAnualSuperaMonto = camposMapper(
                campo.configuracion.gastoEstimadoAnualSuperaMonto
              );
            }

            if (campo?.configuracion?.gastoEstimadoAnualMontoAproximado) {
              campo.configuracion.gastoEstimadoAnualMontoAproximado = camposMapper(
                campo.configuracion.gastoEstimadoAnualMontoAproximado
              );
            }
            if (campo?.configuracion?.verificacionDatos) {
              campo.configuracion.verificacionDatos = camposMapper(
                campo.configuracion.verificacionDatos
              );
            }

            break;

          default:
            break;
        }

        const customProps = processProps(campo?.customProps, sources);

        const containerProps = customProps?.containerProps || {};
        if (customProps?.containerProps) {
          delete customProps.containerProps;
        }

        const mapped = {
          ...campo,
          containerProps: {
            name: campo?.name,
            label: campo?.label,
            helpText: campo?.helpText,
            ...containerProps,
          },
          ...customProps,
          rules: processRules(campo.rules, sources),
          isShowing: true,
        };

        fieldsMappeds[campo?.id] = mapped;
        return mapped;
      };

      const seccionMapper = (seccion) => {
        if (Array.isArray(seccion?.showOn?.fields)) {
          if (!seccion.showOn?.custom) {
            seccion.showOn.entries = {};
            seccion.showOn.fields.forEach((field, index) => {
              const value = seccion?.showOn?.values?.[index];
              seccion.showOn.entries[field] = value;
            });
          } else if (
            typeof seccion?.showOn?.custom === 'string' &&
            seccion?.showOn?.custom?.trim?.() !== '' &&
            seccion?.showOn?.custom?.length !== 0
          ) {
            const funcion = evaluate(seccion.showOn.custom);
            seccion.showOn.custom = funcion(sources);
          }
        }

        if (
          typeof seccion?.copiarSeccionJs === 'string' &&
          seccion?.copiarSeccionJs?.trim?.()?.length > 0
        ) {
          seccion.copiaSeccion = true;
          const callback = evaluate(seccion.copiarSeccionJs);
          seccion.copiarSeccionJs = callback(sources);
        } else if (
          typeof seccion?.codigoSeccionCopiar === 'string' &&
          seccion?.codigoSeccionCopiar?.trim?.()?.length > 0
        ) {
          seccion.copiaSeccion = true;
        } else {
          seccion.copiaSeccion = false;
        }

        return {
          ...seccion,
          secciones: seccion?.secciones?.map?.(seccionMapper) || [],
          campos: seccion.campos.map(camposMapper),
        };
      };

      const mappedSecciones = secciones?.map(seccionMapper);

      await setState({
        secciones: mappedSecciones,
        // campos: fieldsMappeds,
        fields: fieldsMappeds,
        catalogo: sources?.catalogo,
      });
      onFinish && onFinish();
    };
  },
  setFieldState(path, value, extraProps = {}) {
    return ({ setState, getState }) => {
      const prevState = getState();
      const newFields = _.set({ ...prevState.fields }, path, value);
      setState({
        ...prevState,
        fields: newFields,
      });
    };
  },
};
const DynamicFormStore = createStore({
  name: 'DynamicFormState',
  initialState: initialState,
  actions: actions,
});

const hook = createHook(DynamicFormStore);
/**
 *
 * @returns {InitialStateDynamicForm}
 */
export const useDynamicForm = () => {
  const [state, acciones] = hook();

  return {
    ...acciones,
    ...state,
  };
};

export const useDynamicFormFieldById = createStateHook(DynamicFormStore, {
  selector: (state, props) => {
    return {
      field: state.fields[props.fieldId],
    };
  },
});
